module.exports = __webpack_public_path__ + "static/thumb-f13644bd955e3a4182650e24b5d42230.png";